var WMP_PHONE = (window.WMP && window.WMP.phone) || '519-966-8400';
var WMP_TEL = WMP_PHONE.replace(/[^0-9+]/g, '');
// Windsor Mattress Plus — theme.js

document.addEventListener('DOMContentLoaded', function () {

  // ---------- Mobile menu panel ----------
  var navToggle = document.querySelector('.mobile-nav-toggle');
  var mobileMenuPanel = document.querySelector('[data-mobile-menu-panel]');
  var mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');
  var mobileMenuClose = document.querySelector('[data-mobile-menu-close]');

  function openMobileMenu() {
    if (!mobileMenuPanel) return;
    mobileMenuPanel.classList.add('open');
    mobileMenuOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenuPanel) return;
    mobileMenuPanel.classList.remove('open');
    mobileMenuOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (navToggle) navToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);

  // ---------- Mobile accordion (Mattresses / Beds & Furniture expandable sections) ----------
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var isOpen = btn.classList.contains('open');
      btn.classList.toggle('open', !isOpen);
      if (panel) panel.classList.toggle('open', !isOpen);
    });
  });

  // ---------- Product info tabs ----------
  var tabBtns = document.querySelectorAll('.tabbtn');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab');
      document.querySelectorAll('.tabbtn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.tabpanel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.querySelector('.tabpanel[data-tab="' + target + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  document.querySelectorAll('[data-open-tab]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = link.getAttribute('data-open-tab');
      var btn = document.querySelector('.tabbtn[data-tab="' + target + '"]');
      var box = document.getElementById('product-info');
      if (!btn || !box) return;
      e.preventDefault();
      btn.click();
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ---------- Delivery postal code check (zones from Theme settings > Delivery zones) ----------
  var DELIVERY_ZONES = [];
  try { DELIVERY_ZONES = JSON.parse((document.getElementById('delivery-zones') || {}).textContent || '[]'); } catch (e) { DELIVERY_ZONES = []; }
  function normPostal(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function findZone(code) {
    for (var i = 0; i < DELIVERY_ZONES.length; i++) {
      var z = DELIVERY_ZONES[i];
      var list = String(z.codes || '').split(/[,;\n]+/).map(normPostal).filter(Boolean);
      for (var k = 0; k < list.length; k++) {
        var c = list[k];
        if (code.indexOf(c) === 0) return z;
      }
    }
    return null;
  }
  var zonesConfigured = DELIVERY_ZONES.some(function (z) { return normPostal(z.codes); });
  document.querySelectorAll('.zip-check-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      var result = form.parentElement.querySelector('.zipresult') || form.parentElement.querySelector('.ziptext');
      var raw = (input.value || '').trim().toUpperCase();
      var code = normPostal(raw);
      if (!code) return;
      var ordered = ' Items we order in usually arrive within ' + ((window.WMP && window.WMP.orderIn) || '15 business days') + '.';
      var msg;
      var townBox = form.parentElement.querySelector('[data-town-pick]');
      if (townBox) townBox.remove();
      function zoneMsg(z, label) {
        var fee = parseFloat(z.fee);
        return 'Yes, we deliver to ' + label + ' (' + z.name + ').' + (fee > 0 ? ' Delivery is $' + (fee % 1 ? fee.toFixed(2) : fee) + '.' : '') +
          (z.sameDay ? ' When your item is in stock, delivery can be as soon as the same day, subject to availability.' : ' Our team will call you to book your delivery date.') + ordered;
      }
      // N0P is a rural postal code shared by Essex County and Chatham-Kent towns: ask which town
      if (zonesConfigured && code.indexOf('N0P') === 0 && !findZone(code)) {
        var towns = [['Ruthven', 'Leamington'], ['Wheatley', 'Leamington'], ['Comber', 'Leamington'], ['Blenheim', 'Chatham'], ['Tilbury', 'Chatham'], ['Ridgetown', 'Chatham'], ['Merlin', 'Chatham'], ['Dresden', 'Chatham'], ['Thamesville', 'Chatham'], ['Another town', '']];
        var box = document.createElement('div');
        box.className = 'town-pick'; box.setAttribute('data-town-pick', '');
        box.innerHTML = '<label>Which town are you in?<select><option value="">Choose your town</option>' + towns.map(function (t, i) { return '<option value="' + i + '">' + t[0] + '</option>'; }).join('') + '</select></label>';
        if (result) { result.textContent = ''; result.style.display = 'none'; result.parentNode.insertBefore(box, result); } else { form.parentElement.appendChild(box); }
        box.querySelector('select').addEventListener('change', function () {
          var t = towns[this.value]; if (!t) return;
          var z = t[1] ? DELIVERY_ZONES.filter(function (zz) { return String(zz.name || '').indexOf(t[1]) !== -1 && normPostal(zz.codes); })[0] : null;
          var m = z ? zoneMsg(z, t[0]) : 'Please call us at ' + WMP_PHONE + ' and we\u2019ll confirm delivery to your address. You\u2019re also welcome to pick up in store.';
          if (result) { result.textContent = m; result.style.display = 'block'; }
        });
        return;
      }
      if (!zonesConfigured) {
        msg = 'We deliver across Windsor-Essex. Call ' + WMP_PHONE + ' for timing and cost to your address.' + ordered;
      } else {
        var z = code.length >= 3 ? findZone(code) : null;
        if (code.length < 3) {
          msg = 'Please enter your full postal code, for example N8X 3Y4.';
        } else if (z) {
          msg = zoneMsg(z, raw);
        } else {
          msg = 'We may not deliver to ' + raw + ' yet. Please call us at ' + WMP_PHONE + ' and we\u2019ll check for you. You\u2019re also welcome to pick up in store.';
        }
      }
      if (result) { result.textContent = msg; result.style.display = 'block'; }
    });
  });

  // ---------- Product variant selection (size / configuration) ----------
  var pdpForm = document.querySelector('[data-product-form]');
  if (pdpForm) {
    var variantData = JSON.parse(document.getElementById('product-variants-json').textContent);
    var priceEl = document.querySelector('.price-row .now');
    var compareEl = document.querySelector('.price-row .was');
    var variantIdInput = document.querySelector('input[name="id"]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    var availTag = document.querySelector('[data-avail-tag]');
    var optionGroups = document.querySelectorAll('.sizegrid[data-option-index]');

    function findVariant(selections) {
      return variantData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selections[i]; });
      });
    }

    function currentSelections() {
      var selections = [];
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var active = group.querySelector('.sizeopt.selected');
        selections[idx] = active ? active.getAttribute('data-value') : null;
      });
      return selections;
    }

    // For every option group, mark values 'unavailable' if no real variant exists
    // combining that value with whatever is currently selected in the OTHER groups.
    // This is what makes "Add a Foundation" only show real options for the chosen size.
    function refreshAvailability() {
      var selections = currentSelections();

      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var opts = group.querySelectorAll('.sizeopt');
        var anySelectedStillValid = false;

        opts.forEach(function (opt) {
          var value = opt.getAttribute('data-value');
          var testSelections = selections.slice();
          testSelections[idx] = value;
          function fits(v) {
            return v.options.every(function (o, i) {
              return testSelections[i] === null || testSelections[i] === undefined || o === testSelections[i];
            });
          }
          var matches = variantData.some(fits);
          var inStock = variantData.some(function (v) { return v.available && fits(v); });
          opt.classList.toggle('unavailable', !matches);
          opt.setAttribute('aria-disabled', !matches ? 'true' : 'false');
          // Exists but out of stock: still selectable, shown faded with "Out of stock"
          opt.classList.toggle('soldout', matches && !inStock);
          opt.setAttribute('title', matches && !inStock ? 'Out of stock' : '');
          if (matches && opt.classList.contains('selected')) anySelectedStillValid = true;
        });

        // If the currently selected value in this group is no longer valid
        // given the new selection elsewhere, auto-switch to the first valid option.
        if (!anySelectedStillValid) {
          var firstValid = Array.prototype.find.call(opts, function (o) { return !o.classList.contains('unavailable'); });
          if (firstValid) {
            opts.forEach(function (o) { o.classList.remove('selected'); });
            firstValid.classList.add('selected');
          }
        }
      });
    }

    // Purchase Option buttons: show what each foundation adds to the mattress-only price for the chosen size
    var fndGroup = document.querySelector('[data-fnd-group]');
    function priceCents(p) { var n = parseFloat(String(p == null ? '' : p).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
    function fmtAdd(c) { var d = c / 100; return '+$' + (c % 100 ? d.toFixed(2) : String(d)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function refreshAddOns() {
      if (!fndGroup) return;
      var fi = parseInt(fndGroup.getAttribute('data-option-index'), 10);
      var sel = currentSelections();
      function variantWith(val) { var t = sel.slice(); t[fi] = val; return findVariant(t); }
      var onlyBtn = Array.prototype.find.call(fndGroup.querySelectorAll('.sizeopt'), function (b) { return (b.getAttribute('data-value') || '').indexOf('No Box') !== -1; });
      var base = onlyBtn ? variantWith(onlyBtn.getAttribute('data-value')) : null;
      fndGroup.querySelectorAll('.sizeopt').forEach(function (b) {
        var out = b.querySelector('[data-fnd-add]'); if (!out) return;
        var val = b.getAttribute('data-value') || '';
        var v = val.indexOf('No Box') === -1 ? variantWith(val) : null;
        var diff = (v && base) ? priceCents(v.price) - priceCents(base.price) : null;
        out.textContent = (diff != null && diff > 0) ? fmtAdd(diff) : '';
      });
    }

    function updateForSelection() {
      refreshAvailability();
      refreshAddOns();
      var selections = currentSelections();
      var variant = findVariant(selections);
      if (!variant) return;
      variantIdInput.value = variant.id;
      priceEl.textContent = variant.price;
      if (variant.compare_at_price) {
        compareEl.textContent = variant.compare_at_price;
        compareEl.style.display = 'inline';
      } else {
        compareEl.style.display = 'none';
      }
      // Show the photo attached to this variant (e.g. the selected colour), when there is one
      if (variant.image) {
        var mainImg = document.getElementById('main-product-image');
        if (mainImg) mainImg.src = variant.image;
        document.querySelectorAll('.thumb-btn').forEach(function (b) { b.classList.toggle('active', String(b.getAttribute('data-media-id')) === String(variant.media_id)); });
      }
      var cfg = document.querySelector('[data-config-summary]');
      if (cfg) {
        var fnd = variant.options.filter(function (o) { return o.indexOf('Foundation') !== -1; })[0];
        var sz = variant.options.filter(function (o) { return / Mattress$/.test(o); })[0];
        var szTxt = sz ? sz.replace(/ Mattress$/, '') + ' ' : '';
        if (fnd) cfg.innerHTML = 'Price includes: <b>' + (fnd.indexOf('No Box') !== -1 ? szTxt + 'Mattress Only' : szTxt + 'Mattress + ' + fnd.replace(' Box Foundation', ' Foundation').replace(/"/g, '\u2033')).replace(/</g, '&lt;') + '</b>';
      }
      // Sticky bar (phones): keep the current selection visible after scrolling
      var stickySel = document.querySelector('[data-sticky-sel]');
      if (stickySel) {
        stickySel.textContent = variant.options.filter(function (o) { return o && o !== 'Default Title'; }).map(function (o) {
          if (o.indexOf('No Box') !== -1) return 'Mattress Only';
          if (o.indexOf('Box Foundation') !== -1) return 'Mattress + ' + o.replace(' Box Foundation', '').replace(/"/g, '\u2033');
          return o.replace(/ Mattress$/, '');
        }).join(' \u00b7 ');
      }
      var skuRow = document.querySelector('[data-sku-row]');
      if (skuRow) {
        var skuVal = skuRow.querySelector('[data-sku-value]');
        if (skuVal) skuVal.textContent = variant.sku || '';
        skuRow.hidden = !variant.sku;
      }
      var soldoutCall = document.querySelector('[data-soldout-call]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.hidden = !variant.available;
      }
      if (soldoutCall) soldoutCall.hidden = variant.available;
      if (availTag) {
        if (variant.available) { availTag.innerHTML = '<a href="tel:' + (availTag.getAttribute('data-tel') || '') + '" class="avail-tag-link">Ask About Same-Day Delivery</a>'; } else { availTag.textContent = 'This option is out of stock. Call us for timing.'; }
      }

      // Smart cross-sell: switch between "mattress only" and "mattress set" upsells
      // based on whether the currently selected variant includes a foundation/box spring.
      var optText = variant.options.join(' ');
      var isSet = optText.indexOf('Set') !== -1 ||
        (optText.indexOf('Foundation') !== -1 && optText.indexOf('No Box') === -1);
      var csOnly = document.querySelector('[data-crosssell-only]');
      var csSet = document.querySelector('[data-crosssell-set]');
      if (csOnly) csOnly.style.display = isSet ? 'none' : '';
      if (csSet) csSet.style.display = isSet ? '' : 'none';
      if (window.wmRenderSetup) window.wmRenderSetup();
    }

    document.querySelectorAll('.sizeopt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.classList.contains('unavailable')) return;
        var group = opt.closest('.sizegrid');
        group.querySelectorAll('.sizeopt').forEach(function (o) { o.classList.remove('selected'); o.setAttribute('aria-pressed', 'false'); });
        opt.classList.add('selected');
        opt.setAttribute('aria-pressed', 'true');
        updateForSelection();
      });
    });

    // Run once on page load so options are correctly toned down for the default selection
    refreshAvailability();
    refreshAvailability(); // second pass so groups see each other's default selection
    refreshAddOns();
  }

  // ---------- "Complete your setup": size-matched beds / frames ----------
  // Every card is built from the exact variant that matches the mattress size the
  // customer has selected. If no bed comes in that size, nothing is substituted.
  var SIZE_ORDER = ['Twin', 'Double', 'Queen', 'King'];
  function normSize(v) {
    if (!v) return null;
    v = String(v).replace(/\s*(bed only|mattress)$/i, '').trim(); // e.g. "Queen Mattress" -> "Queen"
    if (/^full$/i.test(v)) v = 'Double';
    return v;
  }
  function sizeIndexIn(names) {
    for (var i = 0; i < names.length; i++) { if (/^size$/i.test(names[i])) return i; }
    return -1;
  }
  function selectedMattressSize() {
    var optEl = document.getElementById('product-options-json');
    if (!optEl) return null;
    var idx = sizeIndexIn(JSON.parse(optEl.textContent));
    if (idx < 0) return null;
    var sel = document.querySelector('.sizegrid[data-option-index="' + idx + '"] .sizeopt.selected');
    return sel ? normSize(sel.getAttribute('data-value')) : null;
  }
  function matchItem(item, size) {
    var si = sizeIndexIn(item.options || []);
    if (si >= 0) {
      return { si: si, variants: item.variants.filter(function (v) { return normSize(v.options[si]) === size; }) };
    }
    // Frames without a Size option: use the range in the title, e.g. "Queen to King"
    var m = item.title.match(/\b(Twin|Double|Queen|King)\s+to\s+(Twin|Double|Queen|King)\b/i);
    if (m) {
      var cap = function (x) { return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase(); };
      var lo = SIZE_ORDER.indexOf(cap(m[1])), hi = SIZE_ORDER.indexOf(cap(m[2])), at = SIZE_ORDER.indexOf(size);
      if (at >= lo && at <= hi) return { si: -1, range: cap(m[1]) + ' to ' + cap(m[2]), variants: item.variants };
    }
    return { si: -1, variants: [] };
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  function shuffled(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function renderSetup(root) {
    // Rotate: shuffle once per page load, then keep that order while the customer changes size
    if (!root._csData) root._csData = shuffled(JSON.parse(root.querySelector('[data-cs-json]').textContent || '[]'));
    var data = root._csData;
    var minCents = parseInt(root.getAttribute('data-cs-min') || '0', 10);
    var list = root.querySelector('[data-cs-options]');
    var empty = root.querySelector('[data-cs-empty]');
    var addBtn = root.querySelector('[data-cs-add]');
    var msg = root.querySelector('[data-cs-msg]');
    var label = root.getAttribute('data-cs-label') || 'bed';
    var size = selectedMattressSize();
    var cards = [];
    var pool = data;
    if (size === 'Twin XL') {
      // Twin XL: offer the 6-caster adjustable metal frame (and any bed/base that truly comes in Twin XL)
      var extraEl = root.querySelector('[data-cs-extra]');
      var extra = extraEl ? JSON.parse(extraEl.textContent || '[]') : [];
      pool = data.filter(function (it) { return matchItem(it, size).variants.length; })
        .concat(extra.map(function (it) { return Object.assign({}, it, { twinXlFrame: true }); }));
    }
    function collect(threshold) {
      pool.forEach(function (item) {
        if (cards.length >= 3) return;
        if (cards.some(function (c) { return c.item.url === item.url; })) return;
        var r = item.twinXlFrame ? { si: -1, range: 'Twin XL', variants: item.variants } : matchItem(item, size);
        var v = r.variants.find(function (x) { return x.available && (item.twinXlFrame || !threshold || x.cents >= threshold); });
        if (!v) return; // no orderable variant in this exact size (at this price level): skip, never substitute
        var others = (item.options || []).map(function (name, i) {
          return (i === r.si || v.options[i] === 'Default Title') ? null : v.options[i];
        }).filter(Boolean);
        var meta = [r.range ? 'Fits ' + r.range : size].concat(others.length ? [others.join(' ')] : []).concat(['Available']).join(' · ');
        cards.push({ item: item, v: v, meta: meta, frame: !!item.twinXlFrame });
      });
    }
    if (size) {
      collect(minCents);            // higher-end beds first
      if (minCents && !cards.length) collect(0); // no higher-end bed in this size: show other beds in this size
    }
    list.innerHTML = cards.map(function (c, i) {
      return '<label class="cs-card"><input type="radio" name="cs-' + esc(label) + '" value="' + c.v.id + '"' +
        (c.v.sku ? ' data-sku="' + esc(c.v.sku) + '"' : '') + ' data-title="' + esc(c.item.title) + '">' +
        '<div class="cs-thumb">' + (c.item.image ? '<img src="' + esc(c.item.image) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="cs-body"><h4>' + esc(c.item.title) + '</h4><div class="cs-meta">' + esc(c.meta) + '</div></div>' +
        '<div class="cs-price"><div class="amt">+' + esc(c.v.price) + '</div></div></label>';
    }).join('');
    msg.textContent = '';
    if (!addBtn.getAttribute('data-label')) addBtn.setAttribute('data-label', addBtn.textContent);
    var allFrames = cards.length && cards.every(function (c) { return c.frame; });
    addBtn.textContent = allFrames ? 'Add Frame to Order' : addBtn.getAttribute('data-label');
    if (cards.length) {
      empty.hidden = true;
      addBtn.hidden = false;
      addBtn.disabled = true; // nothing pre-selected: the customer must choose a bed first
    } else {
      empty.hidden = false;
      empty.textContent = size
        ? 'We don’t have a ' + label + ' in ' + size + ' available online right now. Call ' + WMP_PHONE + ' and we’ll help you find one.'
        : 'Choose a mattress size to see matching options.';
      addBtn.hidden = true;
      addBtn.disabled = true;
    }
  }
  window.wmRenderSetup = function () {
    document.querySelectorAll('[data-cs-root]').forEach(renderSetup);
  };
  document.querySelectorAll('[data-cs-root]').forEach(function (root) {
    var btn = root.querySelector('[data-cs-add]');
    root.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') btn.disabled = false;
    });
    var msg = root.querySelector('[data-cs-msg]');
    var label = root.getAttribute('data-cs-label') || 'bed';
    btn.addEventListener('click', function () {
      var original = btn.textContent;
      var selected = root.querySelector('input[type="radio"]:checked');
      if (!selected) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      msg.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(selected.value), quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error((body && (body.description || body.message)) || 'Could not add this ' + label + '.');
            return body;
          });
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          msg.textContent = selected.getAttribute('data-title') + ' was added to your cart.';
          setTimeout(function () { btn.textContent = original; btn.disabled = !root.querySelector('input[type="radio"]:checked'); }, 2000);
          if (typeof openDrawer === 'function') openDrawer();
        })
        .catch(function (err) {
          btn.textContent = original;
          btn.disabled = false;
          msg.textContent = err && err.message ? err.message : 'Something went wrong. Please try again.';
        });
    });
  });
  window.wmRenderSetup();

  // ---------- Cart page: quantity + remove via Shopify's cart API ----------
  // Works without JavaScript too: inputs are named updates[] (Update Cart button) and Remove links use item.url_to_remove.
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var cartFallback = cartForm.querySelector('[data-cart-fallback]');
    if (cartFallback) cartFallback.hidden = true;
    var cartStatus = cartForm.querySelector('[data-cart-status]');
    var cartQueue = Promise.resolve();
    var cartTimers = {};
    var setCartStatus = function (text, isError) {
      if (!cartStatus) return;
      cartStatus.textContent = text || '';
      cartStatus.classList.toggle('is-error', !!isError);
    };
    cartForm.querySelectorAll('[data-cart-qty]').forEach(function (inp) { inp.setAttribute('data-saved', inp.value); });
    var changeCartLine = function (line, qty) {
      cartQueue = cartQueue.then(function () {
        cartForm.classList.add('is-updating');
        setCartStatus('Updating your cart…');
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok) throw new Error((body && (body.description || body.message)) || 'We couldn’t update your cart. Please try again.');
              return body;
            });
          })
          .then(function (cart) {
            if (qty === 0 || cart.item_count === 0) { window.location.reload(); return; }
            var rows = cartForm.querySelectorAll('[data-cart-line]');
            var limited = false;
            cart.items.forEach(function (item, i) {
              var row = rows[i];
              if (!row) return;
              var inp = row.querySelector('[data-cart-qty]');
              if (i === line - 1 && item.quantity < qty) limited = item.quantity;
              inp.value = item.quantity;
              inp.setAttribute('data-saved', item.quantity);
              var lp = row.querySelector('[data-line-price]');
              if (lp) lp.textContent = formatMoney(item.final_line_price);
            });
            var sub = document.querySelector('[data-cart-subtotal]');
            if (sub) sub.textContent = formatMoney(cart.total_price);
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            setCartStatus(limited !== false ? 'Only ' + limited + ' of this item can be ordered online. Call us for more.' : 'Cart updated.', limited !== false);
          })
          .catch(function (err) {
            var inp = cartForm.querySelector('[data-cart-qty="' + line + '"]');
            if (inp) inp.value = inp.getAttribute('data-saved');
            setCartStatus(err && err.message ? err.message : 'We couldn’t update your cart. Please try again.', true);
          })
          .then(function () { cartForm.classList.remove('is-updating'); });
      });
      return cartQueue;
    };
    var queueCartLine = function (inp) {
      var line = parseInt(inp.getAttribute('data-cart-qty'), 10);
      var qty = parseInt(inp.value, 10);
      if (isNaN(qty) || qty < 0) { inp.value = inp.getAttribute('data-saved'); return; }
      if (String(qty) === inp.getAttribute('data-saved')) return;
      clearTimeout(cartTimers[line]);
      cartTimers[line] = setTimeout(function () { changeCartLine(line, qty); }, 350);
    };
    cartForm.querySelectorAll('[data-cart-qty]').forEach(function (inp) {
      inp.addEventListener('change', function () { queueCartLine(inp); });
    });
    cartForm.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var inp = btn.parentNode.querySelector('[data-cart-qty]');
        var next = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
        inp.value = next;
        queueCartLine(inp);
      });
    });
    cartForm.querySelectorAll('[data-cart-remove]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var line = parseInt(link.getAttribute('data-cart-remove'), 10);
        link.textContent = 'Removing…';
        changeCartLine(line, 0);
      });
    });
  }

  // ---------- Cart drawer ----------
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerOverlay = document.querySelector('[data-cart-drawer-overlay]');
  var drawerBody = document.querySelector('[data-cart-drawer-body]');
  var drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    return '$' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
    } else {
      drawerBody.innerHTML = cart.items.map(function (item, idx) {
        return '<div class="cart-drawer-line">' +
          (item.image ? '<img src="' + item.image + '" alt="">' : '<div></div>') +
          '<div><h4>' + item.product_title + '</h4><div class="variant">' +
            ((item.variant_title && item.variant_title !== 'Default Title' && !item.product_has_only_default_variant) ? String(item.variant_title).replace(' Mattress /', ' /').replace('No Box Foundation', 'Mattress Only').replace(/\/ (Standard|Low Profile|Split)/, '/ Mattress + $1').replace(' Box Foundation', '').replace(/"/g, '\u2033').replace(/</g, '&lt;') + ' &middot; ' : '') +
            'Qty ' + item.quantity + '</div>' +
            '<button type="button" class="cart-drawer-remove" data-drawer-remove="' + (idx + 1) + '">Remove</button></div>' +
          '<div class="price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');
    }
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; });
  }

  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-drawer-remove]');
      if (!btn) return;
      btn.disabled = true;
      btn.textContent = 'Removing\u2026';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.getAttribute('data-drawer-remove'), 10), quantity: 0 })
      })
        .then(function (res) { if (!res.ok) throw new Error('remove failed'); return res.json(); })
        .then(function (cart) {
          if (document.querySelector('[data-cart-form]')) { window.location.reload(); return; }
          renderDrawer(cart);
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Couldn\u2019t remove \u2014 try again'; });
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderDrawer);
  }

  function openDrawer() {
    if (!drawer) return;
    refreshCartDrawer();
    drawer.classList.add('open');
    drawerOverlay.classList.add('open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawerOverlay.classList.remove('open');
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // Intercept the main product-form add-to-cart to open the drawer instead of a full page reload
  var pdpForm2 = document.querySelector('.pdp-info form');
  if (pdpForm2) {
    pdpForm2.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(pdpForm2);
      var removalBox = pdpForm2.querySelector('[data-removal-addon]');
      var requestBody = formData;
      var requestHeaders = { 'Accept': 'application/json' };
      if (removalBox && removalBox.checked) {
        // Add the mattress and the old mattress removal service together
        var qty = parseInt(formData.get('quantity'), 10) || 1;
        requestBody = JSON.stringify({ items: [
          { id: formData.get('id'), quantity: qty },
          { id: removalBox.value, quantity: qty }
        ] });
        requestHeaders['Content-Type'] = 'application/json';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: requestHeaders,
        body: requestBody
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) { showCartError(pdpForm2, (r.data && (r.data.description || r.data.message)) || 'Sorry, we couldn\u2019t add this item. Please call us at ' + WMP_PHONE + '.'); return; }
          clearCartError(pdpForm2);
          openDrawer();
        })
        .catch(function () { showCartError(pdpForm2, 'Sorry, something went wrong. Please try again or call us at ' + WMP_PHONE + '.'); });
    });
  }

  function showCartError(form, msg) {
    if (!form) { alert(msg); return; }
    var el = form.querySelector('.cart-error');
    if (!el) { el = document.createElement('p'); el.className = 'cart-error'; el.setAttribute('role', 'alert'); form.appendChild(el); }
    el.textContent = msg;
  }
  function clearCartError(form) { var el = form && form.querySelector('.cart-error'); if (el) el.remove(); }

  // ---------- Quick view ----------
  var qvOverlay = document.querySelector('[data-qv-overlay]');
  var qvContent = document.querySelector('[data-qv-content]');

  function renderQuickView(product) {
    var variant = product.variants[0];
    // Bedroom sets: show the Queen set first, not the cheapest single piece
    if (/Bedroom/.test(product.title || '')) {
      var qs = product.variants.filter(function (v) { return /Queen/.test(v.title) && /Set/.test(v.title); });
      if (qs.length) variant = qs[0];
    }
    var tags = product.tags || [];
    if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
    var isCatalogue = tags.indexOf('Catalogue Order') !== -1;
    var img = product.images && product.images[0] ? product.images[0] : null;
    qvContent.innerHTML =
      '<div class="qv-body">' +
      '<div class="qv-image">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
      '<div class="qv-info">' +
      '<h3>' + product.title + '</h3>' +
      '<div class="price">' + formatMoney(variant.price) + '</div>' +
      '<p class="lede">' + (product.description ? product.description.replace(/<[^>]*>/g, '').slice(0, 160) : '') + '&hellip;</p>' +
      '<div class="ctarow">' +
      (isCatalogue
        ? '<a class="btn btn-primary" href="tel:' + WMP_PHONE.replace(/[^0-9+]/g, '') + '">Call to Order</a>'
        : (variant.available
          ? '<button class="btn btn-primary" data-qv-add data-variant-id="' + variant.id + '">Add to Cart</button>'
          : '<a class="btn btn-primary" href="tel:' + WMP_TEL + '">Out of Stock &ndash; Call ' + WMP_PHONE + '</a>')) +
      '<a href="/products/' + product.handle + '" class="btn btn-outline">View Full Details</a>' +
      '</div></div></div>';

    var addBtn = qvContent.querySelector('[data-qv-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: addBtn.getAttribute('data-variant-id'), quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) { addBtn.insertAdjacentHTML('afterend', '<p class="cart-error" role="alert">Sorry, we couldn\u2019t add this item. Please view full details or call ' + WMP_PHONE + '.</p>'); return; }
          closeQuickView();
          openDrawer();
        });
      });
    }
  }

  function openQuickView(handle) {
    if (!qvOverlay) return;
    qvContent.innerHTML = '<div class="qv-loading">Loading&hellip;</div>';
    qvOverlay.classList.add('open');
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(renderQuickView)
      .catch(function () { qvContent.innerHTML = '<div class="qv-loading">Couldn\'t load this product.</div>'; });
  }
  function closeQuickView() {
    if (qvOverlay) qvOverlay.classList.remove('open');
  }

  document.querySelectorAll('[data-qv-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () { openQuickView(btn.getAttribute('data-handle')); });
  });
  document.querySelectorAll('[data-qv-close]').forEach(function (btn) { btn.addEventListener('click', closeQuickView); });
  if (qvOverlay) {
    qvOverlay.addEventListener('click', function (e) { if (e.target === qvOverlay) closeQuickView(); });
  }

  // ---------- Recently viewed ----------
  var rvSection = document.querySelector('[data-recently-viewed-section]');
  var rvGrid = document.querySelector('[data-recently-viewed-grid]');
  if (rvSection && rvGrid) {
    try {
      var currentHandle = window.location.pathname.split('/products/')[1];
      var viewed = JSON.parse(localStorage.getItem('wmp_recently_viewed') || '[]')
        .filter(function (h) { return h !== currentHandle; })
        .slice(0, 4);
      if (viewed.length > 0) {
        Promise.all(viewed.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; }); }))
          .then(function (products) {
            products = products.filter(Boolean);
            if (products.length === 0) return;
            rvGrid.innerHTML = products.map(function (p) {
              var img = p.images && p.images[0] ? p.images[0] : '';
              return '<a class="prodcard" href="/products/' + p.handle + '">' +
                '<div class="thumb">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
                '<div class="body"><h4>' + p.title + '</h4><div class="price">' + formatMoney(p.price) + '</div></div>' +
                '</a>';
            }).join('');
            rvSection.style.display = 'block';
          });
      }
    } catch (e) { /* localStorage unavailable, skip silently */ }
  }


  // ---------- Mattress quiz (6 questions, live store data) ----------
  (function () {
    var modal = document.querySelector('[data-quiz-modal]');
    var overlay = document.querySelector('[data-quiz-overlay]');
    var body = document.querySelector('[data-quiz-body]');
    var dataEl = document.getElementById('quiz-data');
    if (!modal || !body || !dataEl) return;

    var PRODUCTS = [];
    try { PRODUCTS = JSON.parse(dataEl.textContent) || []; } catch (e) { PRODUCTS = []; }

    // Comfort scores and features from the showroom spec cards, by product handle.
    // New mattresses not listed here fall back to their Comfort field and tags.
    var SPECS = {
      'mika-husky-euro-top-pocket-coil-mattress': { c: 6, cool: 'Copper-infused cooling cover', lum: 1 },
      'misha-husky-euro-top-pocket-coil-mattress': { c: 6.5, cool: 'Active response foam for 2x more airflow', lum: 1 },
      'lauren-husky-pocket-coil-euro-top-mattress': { c: 4.5 },
      'shiloh-husky-euro-top-pocket-coil-mattress': { c: 7.5, cool: 'Active response foam for 2x more airflow', lum: 1 },
      'natural-life-husky-euro-top-pocket-coil-mattress': { c: 4, cool: 'Cooling gel foam layer', lum: 1 },
      'nikita-1000-husky-pocket-coil-mattress': { c: 7, cool: 'Cooling fabric and foams', lum: 1 },
      'nikita-2000-husky-pocket-coil-mattress': { c: 5.5, cool: 'Cooling euro top' },
      'nikita-3000-euro-top-pocket-coil-mattress-set': { c: 7.5, cool: 'Cooling fabric and foams', lum: 1 },
      'sydney-2-sided-husky-tight-top-pocket-coil-mattress': { c: 7.5, cool: 'Active response foam for 2x more airflow' },
      'casey-2-sided-husky-tight-top-mattress': { c: 3.5, cool: 'Copper-infused gel on both sides' },
      'dream-catcher-2-sided-pocket-coil-tight-top-mattress': { c: 7.5, cool: 'Breathable cooling fabric', lum: 1 },
      'tempo-euro-top-hybrid-pocket-coil-mattress': { c: 3.5, cool: 'Cooling foam layers' },
      'prelude-hybrid-pocket-coil-tight-top-mattress': { c: 5.5 },
      'rest-o-pedic-euro-top-mattress': { c: 6 },
      'orthopedic-tight-top-mattress': { c: 6.5 },
      '8-eco-gel-mattress': { c: 5.5, cool: 'Cooling gel foam' },
      '10-eco-gel-memory-foam-mattress': { c: 5.5 },
      'healthy-beds-rx4-mattress': { c: 4, cool: 'Cooling cover and copper-infused foam' }
    };
    window.WMP_SPECS = SPECS;
    var EXCLUDE = ['cozy-rest-foam-mattress']; // kids' mattress, not an adult recommendation
    var SIZES = ['Twin', 'Double', 'Queen', 'King'];
    var TIERS = { Twin: [600, 1400], Double: [650, 1450], Queen: [700, 1500], King: [900, 1900] };
    var FEEL_DEFAULT = { Plush: 3.5, Medium: 5.5, Firm: 7.5 };

    var M = PRODUCTS.filter(function (p) { return EXCLUDE.indexOf(p.h) < 0 && p.p && Object.keys(p.p).length; }).map(function (p) {
      var t = p.tags || [];
      var has = function (x) { return t.indexOf(x) >= 0; };
      var feel = p.comfort || (has('Plush') ? 'Plush' : has('Firm') ? 'Firm' : 'Medium');
      var s = SPECS[p.h] || {};
      return {
        h: p.h, n: p.n, u: p.u, img: p.img, prices: p.p, vids: p.v || {}, f: feel,
        c: s.c != null ? s.c : (FEEL_DEFAULT[feel] || 5.5), lvl: p.cl || feel,
        cool: s.cool || '', lum: !!s.lum, husky: has('Husky'), two: has('2 Sided'),
        foam: has('Foam'), classic: has('Classic'), coil: has('Husky') || has('Hybrid'),
        col: has('Husky') ? 'Husky Collection' : has('Classic') ? 'Classic' : has('Foam') ? 'Foam' : has('Hybrid') ? 'Hybrid' : ''
      };
    });

    var st = { step: 0, a: {}, nudge: 0 };

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
    function money(v) {
      var cents = Math.round(v * 100) % 100;
      var whole = Math.floor(Math.round(v * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + whole + (cents ? '.' + (cents < 10 ? '0' : '') + cents : '');
    }
    // Link straight to the exact mattress-only variant in the chosen size (never another size)
    function link(m, sz) { return m.vids && m.vids[sz] ? m.u + (m.u.indexOf('?') < 0 ? '?' : '&') + 'variant=' + m.vids[sz] : m.u; }
    function sizeName() { return (st.a.size && st.a.size !== 'unsure') ? st.a.size : 'Queen'; }

    function questions() {
      var sz = sizeName(), tier = TIERS[sz];
      return [
        { key: 'size', title: 'What size do you need?', help: '6 quick questions to find your best match.', opts: [
          ['Twin', 'Twin', 'Kids, bunk beds and single sleepers'], ['Double', 'Double', 'Also called Full'], ['Queen', 'Queen', 'Our most popular size'], ['King', 'King', 'The most room for two'], ['unsure', 'Not Sure Yet', 'Over 6′2″? A Queen or King is best']] },
        { key: 'pos', title: 'How do you usually sleep?', help: 'This tells us how soft or firm your mattress should feel.', opts: [
          ['side', 'On My Side', ''], ['back', 'On My Back', ''], ['stomach', 'On My Stomach', ''], ['mix', 'I Switch Positions', '']] },
        { key: 'hot', title: 'Do you sleep hot?', help: 'We’ll favour mattresses with cooling features.', opts: [
          ['often', 'Yes, Often', ''], ['some', 'Sometimes', ''], ['no', 'No', '']] },
        { key: 'pain', title: 'Where would you like extra support or cushioning?', help: 'Choose the one that matters most to you.', opts: [
          ['back', 'Lower Back', ''], ['hips', 'Hips & Shoulders', ''], ['none', 'No Preference', '']] },
        { key: 'who', title: 'Who will sleep on it?', help: 'Couples and larger frames do best with extra support.', opts: [
          ['me', 'Just Me', ''], ['two', 'Me and a Partner', ''], ['sturdy', 'Extra-Sturdy Support', 'For larger frames or heavier builds']] },
        { key: 'budget', title: 'What’s your budget?', help: 'Prices are for a ' + sz + ' mattress. Box foundations are extra.', opts: [
          ['value', 'Under ' + money(tier[0]), ''], ['mid', money(tier[0]) + '–' + money(tier[1]), ''], ['premium', money(tier[1]) + ' and Up', ''], ['any', 'Show Me Everything', '']] }
      ];
    }

    function renderQuestion() {
      var Q = questions(), q = Q[st.step], n = st.step + 1;
      var html = '<div class="qz-progress-row"><span>Question ' + n + ' of 6</span><span>' + (n === 1 ? 'About 1 minute' : (7 - n) + ' left') + '</span></div>' +
        '<div class="qz-bar"><div class="qz-bar-fill" style="width:' + Math.round(n / 6 * 100) + '%"></div></div>' +
        '<h2 class="qz-title">' + esc(q.title) + '</h2><p class="qz-help">' + esc(q.help) + '</p><div class="qz-opts">';
      q.opts.forEach(function (o) {
        var on = st.a[q.key] === o[0];
        html += '<button type="button" class="qz-opt' + (on ? ' is-on' : '') + '" data-qz-key="' + q.key + '" data-qz-val="' + esc(o[0]) + '">' +
          '<span class="qz-opt-text"><span class="qz-opt-label">' + esc(o[1]) + '</span>' + (o[2] ? '<span class="qz-opt-sub">' + esc(o[2]) + '</span>' : '') + '</span>' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>';
      });
      html += '</div>' + (st.step > 0 ? '<button type="button" class="qz-back" data-qz-back>&larr; Back</button>' : '');
      body.innerHTML = html;
      var first = body.querySelector('.qz-opt'); if (first) first.focus();
    }

    function results() {
      var a = st.a, sz = sizeName(), si = sz, tier = TIERS[sz];
      var target = { side: 4, back: 6, stomach: 7.5, mix: 5.5 }[a.pos] || 5.5;
      if (a.pain === 'back') target += 0.5;
      if (a.pain === 'hips') target -= 0.5;
      target = Math.max(2, Math.min(8, target + st.nudge * 1.5));
      var ranked = M.filter(function (m) { return m.prices[si] != null; }).map(function (m) {
        var price = m.prices[si] / 100, s = 10 - Math.abs(m.c - target) * 2;
        if (a.hot === 'often') s += m.cool ? 2 : -2;
        if (a.hot === 'some') s += m.cool ? 1 : 0;
        if (a.pain === 'back' && m.lum) s += 1.5;
        if (a.pain === 'hips' && m.c <= 5.5) s += 1;
        if (a.who === 'two') s += m.coil ? 1 : m.foam ? 0.5 : -1;
        if (a.who === 'sturdy') s += m.husky ? 2.5 : (m.foam || m.classic) ? -2 : 0;
        if (m.classic && a.budget !== 'value') s -= 1.5;
        if (a.budget === 'value') s += price <= tier[0] ? 2 : -(price - tier[0]) / 150;
        if (a.budget === 'mid') s += (price > tier[0] && price <= tier[1]) ? 2 : price <= tier[0] ? 0.5 : -(price - tier[1]) / 200;
        if (a.budget === 'premium') s += price > tier[1] ? 2 : price > tier[0] ? 0.5 : -1;
        return { m: m, score: s, price: price };
      }).sort(function (x, y) { return y.score - x.score; });
      return { ranked: ranked, target: target, sz: sz };
    }

    function reasons(r, sz) {
      var a = st.a, m = r.m, out = [];
      var posText = { side: 'side sleepers', back: 'back sleepers', stomach: 'stomach sleepers', mix: 'combination sleepers' }[a.pos] || 'most sleepers';
      var fit = st.nudge < 0 ? 'a softer option for ' : st.nudge > 0 ? 'a firmer option for ' : 'a good match for ';
      out.push(m.lvl + ' feel, ' + fit + posText + '.');
      if (a.hot !== 'no' && m.cool) out.push(m.cool + ' for cooler sleep.');
      if (a.pain === 'back' && m.lum) out.push('Added support through the lumbar area.');
      if (a.pain === 'hips' && m.c <= 5.5) out.push('Softer comfort layers cushion the hips and shoulders.');
      if ((a.who === 'sturdy' || a.who === 'two') && m.husky) out.push('Husky build: extra support and durability for couples and larger frames.');
      if (a.who === 'two' && !m.husky && m.coil) out.push('Pocket coils limit motion, so you’re less likely to feel your partner move.');
      if (m.two) out.push('Two-sided: flip the mattress to help extend its life.');
      return out.slice(0, 3);
    }

    function renderResults() {
      var R = results(), list = R.ranked, sz = R.sz;
      if (!list.length) {
        body.innerHTML = '<h2 class="qz-title">Let’s find it together</h2><p class="qz-help">We couldn’t match a mattress online for those answers. Visit our showroom or call ' + WMP_PHONE + ' and our sleep specialists will help.</p>';
        return;
      }
      var top = list[0], alts = list.slice(1, 3);
      var check = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#1F7A4D" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      var marker = Math.round(((top.m.c - 1) / 9) * 100);
      var html = '<div class="qz-eyebrow">Your Matches</div>' +
        '<h2 class="qz-title">We recommend the ' + esc(top.m.n.replace(/ Mattress$/, '')) + '</h2>' +
        '<p class="qz-help">' + (st.a.size === 'unsure' ? 'We’ve shown Queen prices. ' : '') + 'Based on your answers, here’s your best match and two more to compare.</p>' +
        '<div class="qz-top-pick"><div class="qz-pick-head"><span class="qz-badge">Best Match</span><span class="qz-col">' + esc(top.m.col) + '</span></div>' +
        (top.m.img ? '<img class="qz-pick-img" src="' + esc(top.m.img) + '" alt="' + esc(top.m.n) + '" loading="lazy">' : '') +
        '<div class="qz-pick-name">' + esc(top.m.n) + '</div>' +
        '<div class="qz-pick-price"><b>' + money(top.price) + '</b> <span>' + sz + ' mattress only</span></div>' +
        '<div class="qz-feel"><div class="qz-feel-labels"><span>Plush</span><b>' + esc(top.m.lvl) + '</b><span>Firm</span></div>' +
        '<div class="qz-feel-track"><span class="qz-feel-dot" style="left:' + marker + '%"></span></div></div><ul class="qz-reasons">';
      reasons(top, sz).forEach(function (t) { html += '<li>' + check + '<span>' + esc(t) + '</span></li>'; });
      html += '</ul><a class="btn btn-primary btn-block" href="' + esc(link(top.m, sz)) + '">View ' + esc(sz) + ' Mattress</a></div>';
      if (alts.length) {
        html += '<h3 class="qz-sub">Also Worth Trying</h3>';
        alts.forEach(function (r) {
          var d = r.m.c - top.m.c;
          var chips = [d >= 1 ? 'A little firmer' : d <= -1 ? 'A little softer' : 'Similar feel'];
          if (r.m.col) chips.push(r.m.col);
          var why = r.m.two ? 'Two-sided: flip the mattress to help extend its life.' : (st.a.hot !== 'no' && r.m.cool) ? r.m.cool + '.' :
            (st.a.pain === 'back' && r.m.lum) ? 'Added support through the lumbar area.' : r.m.husky ? 'Husky build for extra support and durability.' :
            r.m.foam ? 'All-foam comfort that absorbs movement.' : r.m.lvl + ' feel.';
          html += '<a class="qz-alt" href="' + esc(link(r.m, sz)) + '"><span class="qz-alt-head"><span class="qz-alt-name">' + esc(r.m.n) + '</span><b>' + money(r.price) + '</b></span>' +
            '<span class="qz-chips">' + chips.map(function (c) { return '<span class="qz-chip">' + esc(c) + '</span>'; }).join('') + '</span>' +
            '<span class="qz-alt-why">' + esc(r.m.lvl + ' · ' + why) + '</span></a>';
        });
      }
      var base = (document.querySelector('a[href*="/collections/mattresses"]') || {}).getAttribute ? document.querySelector('a[href*="/collections/mattresses"]').getAttribute('href').split('?')[0] : '/collections/mattresses';
      html += '<div class="qz-adjust"><div class="qz-adjust-title">Not quite right?</div><div class="qz-adjust-btns">' +
        '<button type="button" class="btn btn-outline" data-qz-nudge="-1">Show Softer</button><button type="button" class="btn btn-outline" data-qz-nudge="1">Show Firmer</button></div>' +
        '<a class="qz-all" href="' + esc(base) + '?qz_size=' + encodeURIComponent(sz) + '#all-products">Compare All Mattresses in ' + sz + '</a></div>' +
        '<div class="qz-showroom"><h3>Try Our Mattresses in Person</h3>' +
        '<p>For the best fit, visit our showroom and speak with one of our sleep specialists. We can talk you through these models, along with others that may suit your needs.</p>' +
        '<p>2847 Howard Ave, Windsor · No appointment needed</p><div class="qz-adjust-btns">' +
        '<a class="btn btn-outline" href="https://www.google.com/maps/dir/?api=1&amp;destination=Windsor+Mattress+Plus+2847+Howard+Ave+Windsor+ON" target="_blank" rel="noopener">Get Directions</a>' +
        '<a class="btn btn-outline" href="tel:' + WMP_TEL + '">Call Us</a></div></div>' +
        '<button type="button" class="qz-restart" data-qz-restart>Start Over</button>';
      body.innerHTML = html;
      body.scrollTop = 0;
      var h = body.querySelector('.qz-title'); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
    }

    function render() { if (st.step < 6) renderQuestion(); else renderResults(); }
    var lastFocus = null;
    function open() { lastFocus = document.activeElement; st = { step: 0, a: {}, nudge: 0 }; render(); modal.classList.add('open'); if (overlay) overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('open'); if (overlay) overlay.classList.remove('open'); document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }

    document.querySelectorAll('[data-quiz-open]').forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    document.querySelectorAll('[data-quiz-close]').forEach(function (btn) { btn.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    body.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-qz-key]');
      if (opt) { st.a[opt.getAttribute('data-qz-key')] = opt.getAttribute('data-qz-val'); st.step++; st.nudge = 0; render(); return; }
      if (e.target.closest('[data-qz-back]')) { st.step = Math.max(0, st.step - 1); render(); return; }
      var nb = e.target.closest('[data-qz-nudge]');
      if (nb) { st.nudge = Math.max(-2, Math.min(2, st.nudge + parseInt(nb.getAttribute('data-qz-nudge'), 10))); render(); return; }
      if (e.target.closest('[data-qz-restart]')) { st = { step: 0, a: {}, nudge: 0 }; render(); }
    });
  })();


  // ---------- Dynamic per-size price display on product cards ----------
  // Defaults to Twin price (set server-side in product-card.liquid). When a size
  // is selected — either via the quiz or the native "Shop by size" links — swap
  // each card's displayed price to that size's real mattress-only price.
  function formatMoney(cents) {
    var amount = (parseInt(cents, 10) / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + amount;
  }
  function applySizePriceDisplay(sizeValue) {
    if (!sizeValue) return;
    var attrName = 'data-price-' + sizeValue.toLowerCase();
    document.querySelectorAll('.prodcard').forEach(function (card) {
      var priceCents = card.getAttribute(attrName);
      if (priceCents && parseInt(priceCents, 10) > 0) {
        var amountEl = card.querySelector('[data-price-amount]');
        if (amountEl) amountEl.textContent = formatMoney(priceCents);
      }
    });
  }
  (function () {
    var urlParams = new URLSearchParams(window.location.search);
    // Native Shopify size filter uses filter.v.option.size; our quiz uses qz_size.
    var activeSize = urlParams.get('filter.v.option.size') || urlParams.get('qz_size');
    if (activeSize) activeSize = activeSize.replace(/\s*Mattress$/i, '').trim();
    if (activeSize) applySizePriceDisplay(activeSize);
  })();

  // ---------- Weekly flyer: page tabs, markers, deal filters ----------
  (function () {
    var root = document.querySelector('[data-flyer]');
    if (!root) return;
    var pop = root.querySelector('[data-flyer-pop]');
    var active = null;
    function cardHTML(id) { var t = root.querySelector('template[data-flyer-card="' + id + '"]'); return t ? t.innerHTML : ''; }
    // Copy each marker's price into the side list
    root.querySelectorAll('[data-flyer-price-for]').forEach(function (el) {
      var t = root.querySelector('template[data-flyer-card="' + el.getAttribute('data-flyer-price-for') + '"]');
      var pr = t && t.content.querySelector('[data-price]');
      if (pr) el.innerHTML = pr.innerHTML;
    });
    function closePop() {
      if (pop) { pop.hidden = true; pop.innerHTML = ''; }
      root.querySelectorAll('.flyer-pin.is-on, .flyer-row.is-on').forEach(function (el) { el.classList.remove('is-on'); });
      active = null;
    }
    function showPage(n) {
      root.querySelectorAll('[data-flyer-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-flyer-panel') !== String(n); });
      root.querySelectorAll('[data-flyer-list]').forEach(function (p) { p.hidden = p.getAttribute('data-flyer-list') !== String(n); });
      root.querySelectorAll('[data-flyer-tab]').forEach(function (t) {
        var on = t.getAttribute('data-flyer-tab') === String(n);
        t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      closePop();
    }
    function openPin(id) {
      var pin = root.querySelector('.flyer-pin[data-flyer-pin="' + id + '"]');
      if (!pin || !pop) return;
      var panel = pin.closest('[data-flyer-panel]');
      if (panel && panel.hidden) showPage(panel.getAttribute('data-flyer-panel'));
      closePop();
      active = id;
      pin.classList.add('is-on');
      root.querySelectorAll('.flyer-row[data-flyer-pin="' + id + '"]').forEach(function (r) { r.classList.add('is-on'); });
      pop.innerHTML = cardHTML(id);
      pop.hidden = false;
      var canvas = pin.parentElement, x = parseFloat(pin.style.left), y = parseFloat(pin.style.top);
      if (window.innerWidth > 900) {
        var cRect = canvas.getBoundingClientRect(), mRect = pop.parentElement.getBoundingClientRect();
        var left = x < 60 ? (cRect.width * x / 100 + 30) : (cRect.width * x / 100 - 30 - 280);
        var top = Math.max(8, Math.min(cRect.height * y / 100 - 90, cRect.height - 380));
        pop.style.left = (cRect.left - mRect.left + left) + 'px';
        pop.style.top = (cRect.top - mRect.top + top) + 'px';
      } else {
        pop.style.left = ''; pop.style.top = '';
        pop.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-flyer-tab]');
      if (tab) { showPage(tab.getAttribute('data-flyer-tab')); return; }
      var pin = e.target.closest('[data-flyer-pin]');
      if (pin) { var id = pin.getAttribute('data-flyer-pin'); if (active === id) closePop(); else openPin(id); return; }
      if (e.target.closest('[data-flyer-close]')) { closePop(); return; }
      var chip = e.target.closest('[data-chip]');
      if (chip) {
        var k = chip.getAttribute('data-chip');
        root.querySelectorAll('[data-chip]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        root.querySelectorAll('[data-flyer-grid] [data-kind]').forEach(function (card) { card.style.display = (k === 'all' || card.getAttribute('data-kind') === k) ? '' : 'none'; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && active) closePop(); });
  })();

  // ---------- Collection FAQ accordion ----------
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var isOpen = btn.classList.contains('open');
      btn.classList.toggle('open', !isOpen);
      if (panel) panel.classList.toggle('open', !isOpen);
    });
  });


  // ---------- Top bar: today's hours (store time, America/Toronto) ----------
  (function () {
    var slide = document.querySelector('[data-hours-slide]');
    if (!slide) return;
    var out = slide.querySelector('[data-hours-today]');
    var hours = (slide.getAttribute('data-hours') || '').split('|');
    var day;
    try {
      var name = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', weekday: 'short' }).format(new Date());
      day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(name);
    } catch (e) { day = -1; }
    if (day < 0) day = new Date().getDay();
    var today = (hours[day] || '').trim();
    if (!out) return;
    var b = document.createElement('b');
    if (today) {
      b.textContent = 'Open today';
      out.appendChild(b);
      out.appendChild(document.createTextNode(' ' + today + ' \u00b7 '));
    } else {
      b.textContent = 'Closed today';
      out.appendChild(b);
      out.appendChild(document.createTextNode(' \u00b7 '));
    }
  })();

  // ---------- Desktop search: icon opens the search box ----------
  (function () {
    var nav = document.querySelector('nav.site-nav');
    var btn = document.querySelector('[data-search-toggle]');
    var form = document.getElementById('nav-search');
    if (!nav || !btn || !form) return;
    var input = form.querySelector('input');
    function setOpen(open) {
      nav.classList.toggle('search-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && input) input.focus();
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      // On phones the search lives in the menu panel
      if (window.matchMedia && window.matchMedia('(max-width: 960px)').matches) {
        var t = document.querySelector('.mobile-nav-toggle'); if (t) t.click();
        var mi = document.querySelector('.mobile-menu-search input'); if (mi) setTimeout(function () { mi.focus(); }, 250);
        return;
      }
      setOpen(!nav.classList.contains('search-open'));
    });
    form.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(false); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target) && e.target !== btn) setOpen(false); });
  })();

  // ---------- Desktop dropdowns: short hover delay, plus click / tap / keyboard ----------
  (function () {
    var nav = document.querySelector('nav.site-nav');
    var items = document.querySelectorAll('[data-nav-dropdown]');
    if (!nav || !items.length) return;
    nav.classList.add('nav-js');
    var OPEN_DELAY = 150, CLOSE_DELAY = 350;
    function setOpen(item, open) {
      if (open) items.forEach(function (o) { if (o !== item) setOpen(o, false); });
      item.classList.toggle('is-open', open);
      var panel = item.querySelector('.mega-dropdown');
      if (panel) {
        panel.style.transform = '';
        if (open) {
          // Keep the whole dropdown on screen
          var r = panel.getBoundingClientRect(), vw = document.documentElement.clientWidth, dx = 0;
          if (r.right > vw - 16) dx = (vw - 16) - r.right;
          if (r.left + dx < 16) dx = 16 - r.left;
          if (dx) panel.style.transform = 'translateX(calc(-50% + ' + Math.round(dx) + 'px))';
        }
      }
      var btn = item.querySelector('.nav-caret');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    items.forEach(function (item) {
      var timer = null;
      var btn = item.querySelector('.nav-caret');
      var canHover = window.matchMedia ? window.matchMedia('(hover: hover)').matches : true;
      item.addEventListener('mouseenter', function () {
        if (!canHover) return;
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(item, true); }, OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function () {
        if (!canHover) return;
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(item, false); }, CLOSE_DELAY);
      });
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(timer);
        setOpen(item, !item.classList.contains('is-open'));
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && item.classList.contains('is-open')) {
          setOpen(item, false);
          if (btn) btn.focus();
        }
      });
      // Close the dropdown when a link or the quiz button inside it is used
      item.querySelectorAll('.mega-dropdown a, .mega-dropdown button').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(item, false); });
      });
    });
    document.addEventListener('click', function (e) {
      items.forEach(function (item) { if (!item.contains(e.target)) setOpen(item, false); });
    });
  })();

  // ---------- Announcement bar carousel ----------
  var announceSlides = document.querySelectorAll('.announce-slide');
  if (announceSlides.length > 1) {
    var announceIndex = 0;
    announceSlides[0].classList.add('active');
    var announcePaused = false;
    var announceBar = announceSlides[0].parentNode;
    if (announceBar) {
      ['mouseenter', 'focusin'].forEach(function (ev) { announceBar.addEventListener(ev, function () { announcePaused = true; }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { announceBar.addEventListener(ev, function () { announcePaused = false; }); });
    }
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) setInterval(function () {
      if (announcePaused) return;
      announceSlides[announceIndex].classList.remove('active');
      announceIndex = (announceIndex + 1) % announceSlides.length;
      announceSlides[announceIndex].classList.add('active');
    }, 7000);
  } else if (announceSlides.length === 1) {
    announceSlides[0].classList.add('active');
  }


  // ---------- Sale countdown: counts to the sale end date set in theme settings ----------
  (function () {
    var box = document.querySelector('[data-sale-countdown]');
    var clock = document.querySelector('[data-countdown-clock]');
    if (!box || !clock) return;
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((box.getAttribute('data-end') || '').trim());
    if (!m) return;
    var end = new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59);
    function tick() {
      var diff = end - new Date();
      if (diff <= 0) { box.hidden = true; return false; }
      var days = Math.floor(diff / 86400000), hours = Math.floor((diff % 86400000) / 3600000), mins = Math.floor((diff % 3600000) / 60000);
      clock.textContent = (days ? days + 'd ' : '') + hours + 'h ' + mins + 'm';
      box.hidden = false;
      return true;
    }
    if (tick()) setInterval(tick, 60000);
  })();

  // ---------- Contact form: pre-fill the product a shopper asked about ----------
  (function () {
    var box = document.querySelector('textarea[name="contact[body]"]');
    var product = new URLSearchParams(window.location.search).get('product');
    if (box && product && !box.value) box.value = 'I have a question about the ' + product + '.';
  })();

});

// ---------- Cart: add old mattress removal ----------
document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('[data-add-removal]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.getAttribute('data-add-removal'), quantity: 1 }] })
    })
      .then(function () { window.location.reload(); })
      .catch(function () { btn.disabled = false; });
  });
});
});

/* Contact page: highlight today's hours (store time) */
(function () {
  var t = document.querySelector('[data-hours-table]');
  if (!t) return;
  var day;
  try {
    var wd = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', weekday: 'short' }).format(new Date());
    day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(wd);
  } catch (e) { day = new Date().getDay(); }
  var row = t.querySelector('tr[data-day="' + day + '"]');
  if (row) row.classList.add('is-today');
})();


// ---------- Mobile sticky Add to Cart: appears once the main button scrolls out of view ----------
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-sticky-buy]');
  var main = document.querySelector('[data-add-to-cart]');
  if (!bar || !main || !('IntersectionObserver' in window)) return;
  var priceEl = document.querySelector('.price-row .now'), barPrice = bar.querySelector('[data-sticky-price]');
  function syncPrice() { if (priceEl && barPrice) barPrice.textContent = priceEl.textContent; }
  if (priceEl && 'MutationObserver' in window) new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
  var mq = window.matchMedia('(max-width: 960px)');
  var io = new IntersectionObserver(function (entries) {
    var e = entries[0];
    var past = !e.isIntersecting && e.boundingClientRect.top < 0;
    bar.hidden = !(mq.matches && past && !main.hidden && !main.disabled);
    document.body.classList.toggle('has-sticky-buy', !bar.hidden);
  });
  io.observe(main);
  bar.querySelector('[data-sticky-add]').addEventListener('click', function () { syncPrice(); main.click(); });
});

// ---------- Accessibility: Esc closes pop-ups; toggles announce open/closed ----------
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    ['[data-qv-close]', '[data-cart-drawer-close]', '[data-mobile-menu-close]'].forEach(function (sel) {
      var b = document.querySelector(sel);
      if (b && b.offsetParent !== null) b.click();
    });
  });
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setTimeout(function () {
        var item = btn.closest('.faq-item') || btn.parentElement;
        var open = btn.classList.contains('open') || item && (item.classList.contains('open') || item.classList.contains('is-open') || item.classList.contains('active'));
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }, 0);
    });
  });
});
